<template>
  <div>
    <div id="simple-calendar-app">
      <div class="vx-card no-scroll-content">
        <calendar-view
          ref="calendar"
          :displayPeriodUom="calendarView"
          :show-date="showDate"
          :events="simpleCalendarEvents"
          enableDragDrop
          :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
          eventBorderHeight="0px"
          eventContentHeight="1.65rem"
          class="theme-default"
          @click-date="onViewDateEvent"
        >
          <div slot="header" class="mb-4">
            <div class="vx-row no-gutter">
              <!-- Month Name -->
              <div class="vx-col w-1/3 items-center sm:flex hidden">
                <!-- Add new event button -->
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="promptScheduleRequest"
                  >Add</vs-button
                >
              </div>

              <!-- Current Month -->
              <div
                class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last"
              >
                <div class="flex items-center">
                  <feather-icon
                    :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                    @click="updateMonth(-1)"
                    svgClasses="w-5 h-5 m-1"
                    class="cursor-pointer bg-primary text-white rounded-full"
                  />

                  <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{
                    showDate | month
                  }}</span>

                  <feather-icon
                    :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                    @click="updateMonth(1)"
                    svgClasses="w-5 h-5 m-1"
                    class="cursor-pointer bg-primary text-white rounded-full"
                  />
                </div>
              </div>

              <!-- Months, week, Year part of the code -->
              <div class="vx-col sm:w-1/3 w-full flex justify-center">
                <template v-for="(view, index) in calendarViewTypes">
                  <vs-button
                    v-if="calendarView === view.val"
                    :key="String(view.val) + 'filled'"
                    type="filled"
                    class="p-3 md:px-8 md:py-3"
                    :class="{
                      'border-l-0 rounded-l-none': index,
                      'rounded-r-none': calendarViewTypes.length !== index + 1,
                    }"
                    @click="calendarView = view.val"
                    >{{ view.label }}</vs-button
                  >
                  <vs-button
                    v-else
                    :key="String(view.val) + 'border'"
                    type="border"
                    class="p-3 md:px-8 md:py-3"
                    :class="{
                      'border-l-0 rounded-l-none': index,
                      'rounded-r-none': calendarViewTypes.length !== index + 1,
                    }"
                    @click="calendarView = view.val"
                    >{{ view.label }}</vs-button
                  >
                </template>
              </div>
            </div>
          </div>
        </calendar-view>

        <vs-prompt
          class="email-compose"
          title="Apply Change Schedule"
          accept-text="Submit"
          :is-valid="validForm"
          :active.sync="SchedulebuttonPromptActive"
          @close="closeOnOutsideClick"
        >
          <vx-card title="Please fill-out the following information">
            <!-- Current Schedule Table -->
            <h4>Current Schedule</h4>
            <table class="schedule-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Scheduled In</th>
                  <th>Scheduled Out</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(schedule, index) in currentSchedule" :key="index">
                  <td>{{ schedule.day }}</td>
                  <td>{{ schedule.in }}</td>
                  <td>{{ schedule.out }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Arrow Indicator -->
            <div class="arrow-indicator">
              <span>&darr;</span>
            </div>

            <!-- Schedule and Approver Dropdowns -->
            <div class="dropdown-container">
              <div class="Schedule-Group-Dropdown">
                <label class="text-sm opacity-75">Select Schedule</label>
                <v-select
                  v-model="selectedSchedule"
                  :options="scheduleOptions"
                />
              </div>

              <div class="Approver-Group-Dropdown">
                <label class="text-sm opacity-75">Select Approver</label>
                <v-select
                  v-model="selectedApprover"
                  :options="approverOptions"
                />
              </div>
            </div>

            <!-- Shift Details Table -->
            <h4>Shift Type</h4>
            <table class="schedule-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>From</th>
                  <th>To</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Monday</td>
                  <td>August 02, 2024</td>
                  <td>August 02, 2024</td>
                </tr>
              </tbody>
            </table>

            <!-- New Schedule Table -->
            <h4>New Schedule</h4>
            <table class="schedule-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Scheduled In</th>
                  <th>Scheduled Out</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Monday</td>
                  <td>8:00</td>
                  <td>17:00</td>
                </tr>
              </tbody>
            </table>

            <!-- Remarks Text Area -->
            <div class="remarks-container">
              <textarea v-model="remarks" placeholder="Remarks"></textarea>
            </div>
          </vx-card>
        </vs-prompt>

        <vs-prompt
          class="email-compose"
          title="Apply Change Schedule"
          accept-text="Submit Changes"
          :is-valid="validForm"
          :active.sync="DateScheduleonClick"
          @close="closeOnOutsideClick"
        >
          <vx-card class="schedule-card">
            <h3 class="card-title">Current Schedule</h3>
            <h4 class="card-title">{{ formattedDate }}</h4>
            <table class="schedule-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Scheduled In</th>
                  <th>Scheduled Out</th>
                  <th>Total Hours</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="scheduleForSelectedDay">
                  <td>{{ dayOfWeek }}</td>
                  <td>{{ scheduleForSelectedDay.in || "N/A" }}</td>
                  <td>{{ scheduleForSelectedDay.out || "N/A" }}</td>
                  <td>
                    {{
                      calculateTotalHours(
                        scheduleForSelectedDay.in,
                        scheduleForSelectedDay.out
                      )
                    }}
                  </td>
                  <td>
                    {{
                      determineStatus(
                        scheduleForSelectedDay.in,
                        scheduleForSelectedDay.out
                      )
                    }}
                  </td>
                </tr>
                <!-- Show a message if there is no schedule available for the day -->
                <tr v-else>
                  <td colspan="5">No schedule available for {{ dayOfWeek }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Arrow Indicator -->
            <div class="arrow-indicator">
              <span>&darr;</span>
            </div>

            <h4 class="card-title">Updated Schedule</h4>
            <table class="schedule-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Scheduled In</th>
                  <th>Scheduled Out</th>
                  <th>Total Hours</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>

            <!-- Remarks Text Area -->
            <div class="remarks-container">
              <!-- <textarea
                v-model="additionalRemarks"
                placeholder="Remarks"
              ></textarea> -->
              <textarea placeholder="Remarks"></textarea>
            </div>
          </vx-card>
        </vs-prompt>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
export default {
  data() {
    return {
      DateScheduleonClick: false,
      SchedulebuttonPromptActive: false,
      selectedDate: null,
      currentSchedule: [],
      schedule: {
        Monday: {
          in: "08:00",
          out: "18:00",
        },
        Tuesday: {
          in: "08:00",
          out: "18:00",
        },
        Wednesday: {
          in: "08:00",
          out: "18:00",
        },
        Thursday: {
          in: "08:00",
          out: "18:00",
        },
        Friday: {
          in: "08:00",
          out: "17:00",
        },
        Saturday: {
          in: null,
          out: null,
        },
        Sunday: {
          in: null,
          out: null,
        },
      },
      selectedSchedule: null,
      scheduleOptions: [
        { label: "Monday", value: "Monday" },
        { label: "Tuesday", value: "Tuesday" },
        { label: "Wednesday", value: "Wednesday" },
        { label: "Thursday", value: "Thursday" },
        { label: "Friday", value: "Friday" },
        { label: "Saturday", value: "Saturday" },
        { label: "Sunday", value: "Sunday" },
      ],
      selectedApprover: null,
      approverOptions: [
        { label: "John Doe", value: "john_doe" },
        { label: "Jane Smith", value: "jane_smith" },
        { label: "Michael Johnson", value: "michael_johnson" },
        { label: "Emily Davis", value: "emily_davis" },
        { label: "Daniel Brown", value: "daniel_brown" },
      ],

      remarks: "",
      showDate: new Date(),
      calendarView: "month",
      currentMonth: new Date().getMonth(),
      calendarViewTypes: [
        {
          label: "Month",
          val: "month",
        },
        {
          label: "Week",
          val: "week",
        },
        {
          label: "Year",
          val: "year",
        },
      ],
      activePromptAddSegment: false,
      activePromptEditSegment: false,
    };
  },
  created() {
    const data = {
      dateToday: moment(this.curDate).format("YYYY-MM-DD"),
      userId: this.$store.state.AppActiveUser.uid,
    };
  },
  computed: {
    simpleCalendarEvents() {
      return this.$store.state.timekeeping.calendarEvents;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    validForm() {},
    formattedDate() {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(this.selectedDate).toLocaleDateString("en-US", options);
    },
    dayOfWeek() {
      return new Date(this.selectedDate).toLocaleDateString("en-US", {
        weekday: "long",
      });
    },
    scheduleForSelectedDay() {
      // Use dayOfWeek to get the schedule for the selected day
      return this.schedule[this.dayOfWeek];
    },
  },
  methods: {
    promptScheduleRequest() {
      this.SchedulebuttonPromptActive = true;
    },
    onViewDateEvent(date) {
      // Handle the date click event
      this.selectedDate = date;
      this.DateScheduleonClick = true;

      this.currentSchedule = Object.entries(this.schedule).map(
        ([day, times]) => ({
          day,
          in: times.in,
          out: times.out,
        })
      );
    },

    closeOnOutsideClick(event) {
      if (event && event.target === event.currentTarget) {
        this.isPopupVisible = false;
      }
    },

    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
      //console.log( this.showDate.getMonth() + 1)

      this.getAllSegmentsByMonth(this.showDate.getMonth() + 1);
    },
    calculateTotalHours(inTime, outTime) {
      if (!inTime || !outTime) return "N/A";
      const inDate = new Date(`1970-01-01T${inTime}:00`);
      const outDate = new Date(`1970-01-01T${outTime}:00`);
      const diff = (outDate - inDate) / (1000 * 60 * 60); // Convert milliseconds to hours
      return diff > 0 ? `${diff} hours` : "N/A";
    },
    determineStatus(inTime, outTime) {
      if (!inTime || !outTime) return "No Work";
      return "Scheduled";
    },
  },
  components: {
    "v-select": vSelect,
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    VuePerfectScrollbar,
    flatPickr,
  },
};
</script>

<style lang="scss">
// @import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>

<style>
/* Popup overlay styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Header styles */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.popup-header h3 {
  font-size: 1.25rem;
  font-weight: bold;
}

/* Table styles */
.schedule-table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
}

.schedule-table th,
.schedule-table td {
  padding: 0.5rem;
  border: 1px solid #ccc;
  text-align: center;
}

.schedule-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

/* Arrow indicator styles */
.arrow-indicator {
  font-size: 2rem;
  text-align: center;
  margin: 1rem 0;
}

/* Dropdown container styles */
.dropdown-container {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
}

.dropdown-container select {
  padding: 0.5rem;
  font-size: 1rem;
  width: 48%;
}

/* Remarks container styles */
.remarks-container {
  margin: 1rem 0;
}

.remarks-container textarea {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  resize: vertical;
}

.dropdown-container {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.Schedule-Group-Dropdown,
.Approver-Group-Dropdown {
  display: flex;
  flex-direction: column;
}

[dir] #simple-calendar-app .theme-default .cv-day.outsideOfMonth {
  background-color: rgb(181 181 181 / 40%);
}
</style>
